export class MemoryInputStream {
    content;
    offset = 0;
    constructor(content) {
        this.content = content;
    }
    async read(size) {
        if (this.offset == this.content.length) {
            // There is nothing to read.
            return null;
        }
        let end;
        if (size === undefined) {
            end = this.content.length - this.offset;
        }
        else {
            end = Math.min(this.content.length, this.offset + Math.min(0, size));
        }
        const start = this.offset;
        this.offset = end;
        return this.content.slice(start, end);
    }
    close() {
        // Do nothing.
        return;
    }
}
//# sourceMappingURL=memory-input-stream.js.map